<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2814"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2818"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2828"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2826" /></clipPath></defs><g
     id="g2820"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2822"><g
         id="g2824"
         clip-path="url(#clipPath2828)"><g
           id="g2830"
           transform="translate(184.2969,116.8047)"><path
             d="M 0,0 V 37.928 C 0,51.25 16.045,62.957 35.463,69.59 m 70.299,0.709 c 20.351,-6.49 37.644,-18.539 37.644,-32.371 V 0"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2832" /></g><path
           d="M 109.15,15.664 H 402.82 V 74.172 H 109.15 Z"
           style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2834" /><g
           id="g2836"
           transform="translate(7.5,100.1934)"><path
             d="M 0,0 V 50.57 C 0,64.488 10.375,76.139 23.783,78.123 M 101.65,-9.156 V -84.529 H 0 v 50.57"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2838" /></g><g
           id="g2840"
           transform="translate(504.5,100.1934)"><path
             d="M 0,0 V 50.57 C 0,64.318 -10.121,75.826 -23.273,78.037 M -101.68,-9.156 V -84.529 H 0 v 50.57"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2842" /></g><g
           id="g2844"
           transform="translate(85.9648,178.5996)"><path
             d="m 0,0 c 6.377,-0.057 12.67,-2.977 16.809,-8.447 l 40.279,-53.348 h 51.648 c 11.764,0 21.317,-9.553 21.317,-21.316 0,-11.793 -9.553,-21.317 -21.317,-21.317 h -62.22 c -6.436,0 -12.813,2.948 -16.981,8.475 l -33.25,44.023"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2846" /></g><g
           id="g2848"
           transform="translate(427.1699,178.5996)"><path
             d="m 0,0 c -6.775,0.283 -13.578,-2.637 -17.971,-8.447 l -40.281,-53.348 h -51.619 c -11.791,0 -21.344,-9.553 -21.344,-21.316 0,-11.793 9.553,-21.317 21.344,-21.317 h 62.193 c 6.463,0 12.813,2.948 17.008,8.475 L 2.551,-51.93"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2850" /></g><g
           id="g2852"
           transform="translate(85.7656,336.377)"><path
             d="m 0,0 h 128.467 c 20.89,0 37.984,17.092 37.984,37.984 v 84.018 c 0,20.863 -17.094,37.957 -37.984,37.957 H -36.17 c -20.893,0 -37.984,-17.094 -37.984,-37.957 V 37.984 C -74.154,17.092 -57.063,0 -36.17,0 v -36.17 z"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2854" /></g><g
           id="g2856"
           transform="translate(306.8398,307.5195)"><path
             d="m 0,0 h 44.078 l 36.17,-36.17 V 0 C 95.98,0 108.85,12.898 108.85,28.631 v 72.226 c 0,15.733 -12.87,28.602 -28.602,28.602 H -54.623 M -106.668,28.857 C -106.668,12.982 -93.969,0 -78.039,0 h 44.08"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2858" /></g><g
           id="g2860"
           transform="translate(62.4922,416.3691)"><path
             d="M 0,0 H 138.842 M 0,-39.457 H 69.422 M 0,39.459 h 138.842"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2862" /></g><g
           id="g2864"
           transform="translate(295.1035,209.2422)"><path
             d="m 0,0 c 0,-22.252 -18.227,-40.479 -40.479,-40.479 -22.251,0 -40.478,18.227 -40.478,40.479 v 43.371 c 0,12.471 10.205,22.649 22.678,22.649 L 0,66.02 Z"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2866" /></g><g
           id="g2868"
           transform="translate(17.8477,209.2422)"><path
             d="m 0,0 c 0,-22.252 18.227,-40.479 40.479,-40.479 22.251,0 40.478,18.227 40.478,40.479 v 43.371 c 0,12.471 -10.205,22.649 -22.648,22.649 H 22.648 C 10.205,66.02 0,55.842 0,43.371 Z"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2870" /></g><g
           id="g2872"
           transform="translate(494.125,209.2422)"><path
             d="M 0,0 C 0,-22.252 -18.199,-40.479 -40.451,-40.479 -62.73,-40.479 -80.93,-22.252 -80.93,0 v 43.371 c 0,12.471 10.176,22.649 22.649,22.649 h 35.633 C -10.178,66.02 0,55.842 0,43.371 Z"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2874" /></g><g
           id="g2876"
           transform="translate(17.8477,207.8242)"><path
             d="m 0,0 c 38.834,-11.934 48.473,12.559 49.605,34.951 0,0 13.438,-12.556 31.352,-5.924"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2878" /></g><g
           id="g2880"
           transform="translate(494.125,207.8242)"><path
             d="m 0,0 c -38.836,-11.934 -48.473,12.559 -49.578,34.951 0,0 -13.465,-12.556 -31.352,-5.924"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2882" /></g><g
           id="g2884"
           transform="translate(214.1465,239.5449)"><path
             d="M 0,0 H 80.957"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2886" /></g></g></g></g></svg>
</template>
